import React from 'react'
import PropTypes from 'prop-types';
import { Link } from 'gatsby';
import Features from './Features';

const IndexPageTemplate = ({
  image,
  title,
  heading,
  subheading,
  mainpitch,
  description,
  intro,
  blogPosts = [],
}) => {
  return (
    <div>
      {/* Hero Section */}
      <div
        className="page-hero full-width-image margin-top-0"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url(${image})`,
        }}
      >
        <div className="hero-content-centered has-text-centered animate-fade-in-up">
          <h1 className="title is-1-desktop is-2-tablet is-3-mobile has-text-weight-bold hero-title mb-4">
            {title}
          </h1>
          <h2 className="subtitle is-3-desktop is-4-tablet is-5-mobile has-text-weight-normal hero-subtitle mb-5">
            {subheading}
          </h2>
          <Link
            className="button is-primary is-large-desktop is-medium-tablet is-normal-mobile is-rounded btn-primary-animated"
            to="/about"
          >
            Learn More About Us
          </Link>
        </div>
      </div>

      {/* Mission Section - Full Width with Background */}
      <section className="section py-6-desktop py-5-tablet py-4-mobile">
        <div className="container">
          <div className="columns is-centered">
            <div className="column is-11-mobile is-10-tablet is-8-desktop is-7-widescreen">
              <div className="box main-pitch-section has-text-centered animate-slide-in-left animate-delay-1">
                <h2 className="title is-2-desktop is-3-tablet is-4-mobile main-pitch-title mb-4">
                  {mainpitch.title}
                </h2>
                <p className="subtitle is-4-desktop is-5-tablet is-6-mobile main-pitch-description">
                  {mainpitch.description}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Focus Areas Section - Full Width with Alternate Background */}
      <section className="section py-6-desktop py-5-tablet py-4-mobile about-section-bg animate-fade-in-up animate-delay-2">
        <div className="container">
          <div className="columns is-centered">
            <div className="column is-11-mobile is-10-tablet is-10-desktop">
              <div className="has-text-centered mb-6">
                <h3 className="title is-2-desktop is-3-tablet is-4-mobile services-title mb-4">
                  {heading}
                </h3>
                <p className="subtitle is-4-desktop is-5-tablet is-6-mobile services-description">
                  {description}
                </p>
              </div>

              {/* Features Component with enhanced styling */}
              <Features gridItems={intro.blurbs} />

              {/* Call to Action for Services */}
              <div className="has-text-centered mt-6">
                <Link
                  className="button is-primary is-large-desktop is-medium-tablet is-normal-mobile is-rounded btn-primary-animated"
                  to="/products"
                >
                  Explore All Services
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Latest Publications Section */}
      <section className="section py-6-desktop py-5-tablet py-4-mobile animate-fade-in-up animate-delay-3">
        <div className="container">
          <div className="columns is-centered">
            <div className="column is-12-mobile is-12-tablet is-10-desktop">
              <div className="box blog-section-enhanced">
                        <div className="has-text-centered mb-5">
                          <h3 className="title is-3-desktop is-4-tablet is-5-mobile blog-title">
                            Latest Publications
                          </h3>
                          <p className="subtitle is-5-desktop is-6-mobile blog-section-subtitle">
                            Discover our recent research and insights
                          </p>
                        </div>

                        {/* Blog Posts Carousel */}
                        {blogPosts && blogPosts.length > 0 ? (
                          <div className="blog-grid-wrapper">
                            <div className="blog-grid-scroll">
                              {blogPosts.map(({ node: post }) => (
                                <div key={post.id} className="blog-grid-item">
                                  <Link to={post.fields.slug} className="card-link-wrapper">
                                    <div className="card blog-card-home hover-lift">
                                      {post.frontmatter.featuredimage ? (
                                        <div className="card-image blog-card-image">
                                          <figure className="image is-16by9">
                                            <img
                                              src={post.frontmatter.featuredimage}
                                              alt={post.frontmatter.title}
                                            />
                                          </figure>
                                        </div>
                                      ) : (
                                        <div className="card-image blog-card-placeholder">
                                          <figure className="image is-16by9">
                                            <span className="blog-card-icon">
                                              <i className="fas fa-newspaper"></i>
                                            </span>
                                          </figure>
                                        </div>
                                      )}
                                      <div className="card-content">
                                        <div className="mb-3">
                                          {post.frontmatter.category && (
                                            <span className="tag is-primary is-light is-small">
                                              {post.frontmatter.category}
                                            </span>
                                          )}
                                          {post.frontmatter.featuredpost && (
                                            <span className="tag is-warning is-light is-small ml-2">
                                              <span className="icon is-small">
                                                <i className="fas fa-star"></i>
                                              </span>
                                              <span>Featured</span>
                                            </span>
                                          )}
                                        </div>
                                        <h4 className="title is-5 blog-card-title-truncate">
                                          {post.frontmatter.title}
                                        </h4>
                                        <p className="blog-card-excerpt-truncate is-size-6 mb-3">
                                          {post.excerpt}
                                        </p>
                                        <p className="blog-card-date is-size-7">
                                          <span className="icon-text">
                                            <span className="icon is-small">
                                              <i className="fas fa-calendar"></i>
                                            </span>
                                            <span>{post.frontmatter.date}</span>
                                          </span>
                                        </p>
                                      </div>
                                    </div>
                                  </Link>
                                </div>
                              ))}
                            </div>
                            <div className="blog-scroll-hint">
                              <span className="icon">
                                <i className="fas fa-chevron-left"></i>
                              </span>
                              <span>Swipe for more publications</span>
                              <span className="icon">
                                <i className="fas fa-chevron-right"></i>
                              </span>
                            </div>
                          </div>
                        ) : (
                          <div className="has-text-centered py-5">
                            <span className="icon is-large has-text-grey-light mb-3">
                              <i className="fas fa-book-open fa-3x"></i>
                            </span>
                            <p className="title is-6 has-text-grey">
                              Publications Coming Soon
                            </p>
                            <p className="subtitle is-6 has-text-grey-light">
                              We\'re preparing our research articles
                            </p>
                          </div>
                        )}

                        <div className="has-text-centered mt-5">
                          <Link
                            className="button is-outlined is-primary is-medium-desktop is-normal-mobile is-rounded btn-outline-animated"
                            to="/blog"
                          >
                            View All Publications
                          </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

IndexPageTemplate.propTypes = {
  image: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  title: PropTypes.string,
  heading: PropTypes.string,
  subheading: PropTypes.string,
  mainpitch: PropTypes.object,
  description: PropTypes.string,
  intro: PropTypes.shape({
    blurbs: PropTypes.array,
  }),
  blogPosts: PropTypes.array,
};

export default IndexPageTemplate;
